/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var $datatable = $('#datatable-rent-payments'),
        rentId = $datatable.data('rent'),
        columns = [
            {data: 'due_date', name: 'due_date'},
            {data: 'amount', name: 'amount'},
            {data: 'status', name: 'status'},
            {data: 'amount_paid', name: 'amount_paid'},
            {data: 'outstanding_amount', name: 'outstanding_amount'},
            {data: 'bank_account', name: 'bank_account'},
            { data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ];

    $datatable.DataTable({
        "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [ 30, 10, 25, 50, 75, 100],
        "ajax": helper.getOrigin() + "/api/payments/rent/" + rentId,
        "bAutoWidth" : false,
        "order": [[ 0, "desc" ]],
        "columns": columns
    });

});
